import { render, staticRenderFns } from "./AILoader.vue?vue&type=template&id=0be456e6&scoped=true&"
import script from "./AILoader.vue?vue&type=script&lang=js&"
export * from "./AILoader.vue?vue&type=script&lang=js&"
import style0 from "./AILoader.vue?vue&type=style&index=0&id=0be456e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be456e6",
  null
  
)

export default component.exports